<template>
    <div class="white-container full-page-container common-table">
      <el-button size="small" type="primary" icon="el-icon-plus" style="position: absolute;top: -50px;right: 0;" @click="add">新增</el-button>
      <div ref="tableBox" class="activity-table">
        <tableList ref="multipleTable" size="small" :query-function="$Api.curriculumCollectionManagement.courseCollectionPageList" style="width: 100%">
          <el-table-column prop="id" label="课程集合ID"/>
          <el-table-column prop="title" label="课程集合页标题"/>
          <el-table-column prop="status" label="活动状态">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === 1" type="success" size="mini">已发布</el-tag>
              <el-tag v-if="scope.row.status === 0" class="el-tag--yellow" size="mini">草稿</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="releaseTime" label="课程发布时间">
            <template v-slot="{row}">
              <span> {{ row.releaseTime ? $moment(row.releaseTime).format('YYYY-MM-DD HH:mm:ss') : '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <el-button size="small" type="text" class="link-color" @click="remove(scope.row)">删除</el-button>
              <el-button size="small" type="text" class="link-color" @click="copyLink(scope.row.pageUrl)">复制链接</el-button>
              <el-button v-if="scope.row.status !== 1" size="small" type="text" class="link-color" @click="edit(scope.row.id)">编辑</el-button>
              <el-button v-if="scope.row.status === 0" size="small" type="text" class="link-color" @click="postOnlineTask(scope.row.id)">发布</el-button>
            </template>
          </el-table-column>
        </tableList>
        <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="submitSuccess" />
    </div>
    </div>
</template>
<script>
import tableList from '@/components/TableList';
import Dialog from '@/components/Dialog';
export default {
  components: { tableList, Dialog },
  data() {
    return {
      formDialogShow: false,
      information: {},
      currentID: -1,
    }
  },
  created(){
  },
  computed:{
  },
  methods:{
    submitSuccess(operation) {
      if(operation === 'edit'){
        this.$router.push({ path: '/curriculumCollectionManagement/edit', query: { id: this.currentID } });
      }else if(operation === 'delete'){
        this.$Api.curriculumCollectionManagement.courseCollectionPageDelete(this.currentID).then(() => {
          this.formDialogShow = false;
          this.$message.success('删除成功');
          this.$refs['multipleTable'].getTableList();
        }).catch(error => {
          this.formDialogShow = true;
          this.information = {
            operation: 'error',
            icon: 'error',
            subTitle: `${error.errorMessage}`,
          };
        });
      }else if(operation === 'publish'){
        this.$Api.curriculumCollectionManagement.courseCollectionPagePublish(this.currentID).then(() => {
          this.$message.success('上传成功');
          this.$refs['multipleTable'].getTableList();
        });
      }
    },
    /** 复制链接 */
    copyLink(path) {
      navigator.clipboard.writeText(path).then(() => {
        this.$message.success('复制成功');
      }).catch(() => {
        this.$message.error('复制失败');
      });
    },
    /** 删除 */
    remove(row){
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: 'delete',
        icon: 'warn',
        subTitle: '删除后用户无法在小程序查看该课程集合页, 请确认是否删除',
      };
    },
    /** 发布 */
    postOnlineTask(id) {
      this.formDialogShow = true;
      this.currentID = id;
      this.information = {
        operation: 'publish',
        icon: 'warn',
        subTitle: `是否确认发布活动ID为“${id}”的数据项？`,
      };
    },
    /** 新增页面 */
    add() {
      this.$router.push({ path: '/curriculumCollectionManagement/edit' });
    },
    /** 编辑页面 */
    edit(id){
      this.formDialogShow = true;
      this.currentID = id;
      this.information = {
        operation: 'edit',
        icon: 'warn',
        subTitle: `是否确认编辑任务ID为“${id}”的数据项？`,
      };
    },
  },
}
</script>
<style lang="less" scoped>
.el-dialog__wrapper {
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  /deep/ .share-wrapper {
    width: 580px;
    margin: unset !important;
    .el-dialog__header {
      height: 6.85vh !important;
      line-height: 6.85vh;
      padding: 0 2.87vh 0 2.78vh !important;
      background: #000000 !important;
      box-sizing: border-box !important;
      .el-dialog__title {
        font-family: "Noto Sans SC";
        font-style: normal;
        font-weight: 500;
        font-size: 1.48vh;
        color: #ffffff;
      }
      .el-dialog__headerbtn {
        top: 2.87vh;
        right: 2.87vh;
        font-size: 1.11vh;
        .el-dialog__close {
          color: #ffffff;
          &:hover {
            color: #dc0019;
          }
        }
      }
    }
    .el-dialog__body {
      padding: 30px;
      .upload-wrap {
        width: 100%;
        height: 236px;
        background: #f7f7f7;
        border: 1px dashed #bbbbbb;
        border-radius: 4px;
        padding: 20px 30px;
        box-sizing: border-box;
        .el-upload-dragger {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .tips {
          font-family: "Noto Sans SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: #494949;
          margin-bottom: 20px;
        }
        .upload-box {
          width: 100%;
          height: 156px;

          .el-upload.el-upload--text {
            width: 100%;
            height: 100%;
            .el-upload-dragger {
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              border: 1px solid #bbbbbb;
              border-radius: 4px;
              &:hover {
                border-color: #1c1c1c;
              }
              .file {
                line-height: 20px;
                margin-top: 5.68px;
              }
              .el-button {
                margin-top: 10px;
              }
            }
          }
        }
      }
    }
    .btns {
      justify-content: center;
      margin-top: 30px;
      .el-button {
        width: 120px;
        height: 50px;
      }
      .el-button + .el-button {
        margin-left: 30px;
      }
    }
  }
}
</style>
